<template>
  <div id="app">
    <div class="view-box" :class="{ tabber: $route.meta.tabbar }">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
    <!-- :to="'/card/package?branchId=' + branchId + '&branchName=' + branchName" -->
    <!-- <van-tabbar
      class="bc-tabber"
      v-if="$route.meta.tabbar"
      route
      :safe-area-inset-bottom="false"
    >
      <van-tabbar-item :replace="true" icon="paid" to="/card/package"
        >订餐</van-tabbar-item
      >
      <van-tabbar-item :replace="true" icon="gift-card-o" to="/nutitron/home"
        >营养</van-tabbar-item
      >
      <van-tabbar-item :replace="true" to="/order/list" icon="send-gift-o"
        >订单</van-tabbar-item
      >
      <van-tabbar-item :replace="true" to="/me/index" icon="user-o"
        >我的</van-tabbar-item
      >
    </van-tabbar> -->
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      branchId: "",
      branchName: "",
      loginType: localStorage.getItem('loginType') || ""
    };
  },
  created() {
    this.branchId = sessionStorage.getItem("branchId");
    this.branchName = sessionStorage.getItem("branchName");
  },
  methods: {
  },
};
</script>

<style lang="scss">
@media (min-width: 1200px) {
  $max-width: 500px;
  #app {
    width: $max-width;
    margin: 0 auto;
    .bc-tabber,
    .h-search,
    .van-nav-bar--fixed,
    .footer,
    .cell-nav-box_pc,
    .center-pc-common,
    ._search,
    .van-popup {
      width: $max-width;
      left: 50%;
      transform: translate(-50%);
    }
    .btns-box_pc {
      width: $max-width;
    }
    .orderfood {
      .content {
        display: flex;
        .left {
          min-width: 100px;
        }
      }
    }
  }
  html,
  body {
    font-size: 46px !important;
    background-color: #f9f9f9;
  }
}
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; */
  /* min-height: 100vh; */
}
.view-box {
  // min-height: 100vh;
}
.view-box .tabber {
  // padding-bottom: 50px;
}
._page {
  padding-top: 50px;
  min-height: 100vh;
  background-color: #f8f8f8;
}
</style>
